export default [
	{
		modulo: 1,
		privilegio: 1,
		routerName: 'solicitacao',
		routerPath: '/solicitacao',
		componentName: 'Solicitacao',
		componentPath: 'modules/layout/solicitacao/default/main',
		clientsComponentPath: [
			// id do ibama
			{
				clientId: [5],
				componentPath: 'modules/layout/solicitacao/ibama/main'
			},
			// ID DA AEROTERRA
			{
				clientId: [13, 21],
				componentPath: 'modules/layout/solicitacao/aero-terra/main'
			},
			//id do gta-sergipe
			{
				clientId: [24],
				componentPath: 'modules/layout/solicitacao/sergipe/main'
			},
			//id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/solicitacao/maranhao/main'
			},
			// id casa militar bahia
			{
				clientId: [8],
				componentPath: 'modules/layout/solicitacao/cm-bahia/main'
			},
			// id da henrimar
			{
				clientId: [25, 37],
				componentPath: 'modules/layout/solicitacao/vale/main'
			}
		]
	},
	{
		modulo: 8,
		privilegio: 223,
		routerName: 'cadastro-tipo-carga',
		routerPath: '/cadastro-tipo-carga',
		componentName: 'TipoCarga',
		componentPath: 'modules/layout/admin-geral/tipo-carga/main'
	}
]
